export default [
  {
    path: '/settings/checklist-dictionary/list',
    name: 'settings-checklist-dictionary-list',
    meta: {
      breadcrumb: [
        { text: 'conf.title' },
        { text: 'conf.settings.title' },
        { text: 'conf.settings.checklist-dictionary.title', active: true },
      ],
      pageTitle: 'conf.settings.checklist-dictionary.title',
      roles: ['ROLE_CONFIG_MANAGEMENT'],
    },
    component: () => import('@/views/settings/ChecklistDictionary/ChecklistDictionaryList/ChecklistDictionaryList'),
  },
  {
    path: '/settings/checklist-dictionary/edit/:id',
    name: 'settings-checklist-dictionary-edit',
    meta: {
      breadcrumb: [
        { text: 'conf.title' },
        { text: 'conf.settings.title' },
        { text: 'conf.settings.checklist-dictionary.title', to: '/settings/checklist-dictionary/list' },
        { text: 'conf.settings.checklist-dictionary.edit-title', active: true },
      ],
      pageTitle: 'conf.settings.checklist-dictionary.title',
      roles: ['ROLE_CONFIG_MANAGEMENT'],
    },
    component: () => import('@/views/settings/ChecklistDictionary/ChecklistDictionaryEdit/ChecklistDictionaryEdit'),
  },
  {
    path: '/settings/team-definition/list',
    name: 'settings-team-definition-list',
    meta: {
      breadcrumb: [
        { text: 'conf.title' },
        { text: 'conf.settings.title' },
        { text: 'conf.settings.team-definition.title', active: true },
      ],
      pageTitle: 'conf.settings.team-definition.title',
      roles: ['ROLE_CONFIG_MANAGEMENT'],
    },
    component: () => import('@/views/settings/TeamDefinition/TeamDefinitionList/TeamDefinitionList'),
  },
  {
    path: '/settings/team-definition/edit/:id',
    name: 'settings-team-definition-edit',
    meta: {
      breadcrumb: [
        { text: 'conf.title' },
        { text: 'conf.settings.title' },
        { text: 'conf.settings.team-definition.title', to: '/settings/team-definition/list' },
        { text: 'conf.settings.team-definition.edit-title', active: true },
      ],
      pageTitle: 'conf.settings.team-definition.title',
      roles: ['ROLE_CONFIG_MANAGEMENT'],
    },
    component: () => import('@/views/settings/TeamDefinition/TeamDefinitionEdit/TeamDefinitionEdit'),
  },
]
